import React from "react";
import { CheckCircle, XCircle, Clock } from "lucide-react";
import { Badge } from "../ui/badge";

export const getStatusBadge = (status, t) => {
  const statusConfig = {
    pending: { variant: "outline", icon: Clock, labelKey: "planning.overridesPanel.statuses.pending" },
    approved: { variant: "default", icon: CheckCircle, labelKey: "planning.overridesPanel.statuses.approved" },
    rejected: { variant: "destructive", icon: XCircle, labelKey: "planning.overridesPanel.statuses.rejected" },
  };
  const cfg = statusConfig[status] || statusConfig.pending;
  const Icon = cfg.icon;
  return (
    <Badge variant={cfg.variant} className="gap-1">
      <Icon className="h-3 w-3" />
      {t(cfg.labelKey)}
    </Badge>
  );
};

export const getPriorityBadge = (priority, t) => {
  const priorityConfig = {
    1: { color: "bg-muted text-muted-foreground", labelKey: "planning.overridesPanel.priorities.low" },
    5: { color: "bg-yellow-950/30 text-yellow-400", labelKey: "planning.overridesPanel.priorities.medium" },
    10: { color: "bg-orange-950/30 text-orange-400", labelKey: "planning.overridesPanel.priorities.high" },
  };
  const cfg = priorityConfig[priority] || priorityConfig[5];
  return <Badge className={cfg.color}>{t(cfg.labelKey)}</Badge>;
};

export const formatDate = (dateStr, locale = "fr") =>
  new Intl.DateTimeFormat(locale, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  }).format(new Date(dateStr));
